import React from 'react';
import { Typography } from '@mui/material';
import MenuBookIcon from '@mui/icons-material/MenuBook';

const Raw = props => {
    return (
        <Typography variant="reference" component="span" sx={{display: "flex", alignItems: "center"}}>
            <MenuBookIcon/>
            {props.description}
        </Typography>
    )
}

export default Raw;